
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.8695 0.890625C11.3691 0.890559 11.7742 1.29551 11.7742 1.7951L11.7753 9.98671L19.9663 9.98726C20.466 9.98726 20.8709 10.3923 20.8708 10.8919C20.8708 11.3915 20.4659 11.7964 19.9663 11.7964L11.7756 11.7959L11.7767 19.9859C11.7768 20.4855 11.3718 20.8905 10.8722 20.8906C10.3726 20.8907 9.96756 20.4857 9.96747 19.9861L9.96638 11.7958L1.77539 11.7953C1.27579 11.7952 0.870816 11.3902 0.87085 10.8906C0.870882 10.391 1.27591 9.98599 1.77551 9.98608L9.96611 9.98662L9.96503 1.79534C9.96503 1.29574 10.3699 0.890691 10.8695 0.890625Z","fill":"#8338EC"}})])
          )
        }
      }
    